<div class="modal-header" id="cancellation-modal-title">
    <h3 class="modal-title" translate="DASHBOARD_NOTIFICATION_CANCELATION_TITLE"></h3>
    <span *ngIf="!disableModalClose" class="close" (click)="modalInstance.hide()">&times;</span>
</div>
<div class="modal-body" id="modal-body">
    <div class="row">
        <div class="col-12">
            <p>{{ model.contactName }}</p>
            <p>{{ model.notificationType }}</p>
            <p
                *ngIf="isNotificationInProgressAndCancelled"
                translate="DASHBOARD_NOTIFICATION_CANCELLATION_IN_PROGRESS"
            ></p>
        </div>
    </div>
</div>
<div class="modal-footer">
    <button class="btn btn-primary" type="button" *ngIf="!isLoading" (click)="sendCancellation()">
        {{ cancellationLabel }}
    </button>
    <progressbar
        [striped]="true"
        [value]="100"
        *ngIf="isLoading"
        [attr.aria-label]="'DASHBOARD_NOTIFICATION_CANCELLATION_IN_PROGRESS_LABEL' | translate"
        >Confirming...</progressbar
    >
</div>
